/**
 * @expFlag promo-in-webview-public
 * @ticket CLOUDWEB-20374
 * @file
 */
import { type BaseRendererComponentProps, BaseModel, BaseModelProps } from '@mail/3promo';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import animatedTrendVariantA from 'img/public/animatedTrendModal/a.mp4';
import React from 'react';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { abPromoInWebviewPublic, PROMO_ID } from 'reactApp/appHelpers/featuresHelpers/features/promoInWebviewPublic';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { store as reduxStore } from 'reactApp/store';

class PopupModel extends BaseModel<BaseModelProps> {
    getParent(): HTMLElement | null {
        return document.documentElement;
    }
}

const LazyComponent = React.lazy(() => import('reactApp/ui/Mobile/PublicAnimatedTrendModal/PublicAnimatedTrendModal'));

const SuspendedComponent = <P extends BaseRendererComponentProps>(props: P) => {
    return (
        <React.Suspense fallback={null}>
            <LazyComponent {...props} />
        </React.Suspense>
    );
};

export const promoInWebviewPublicCreator: ModelCreator = ({ models, render, stores }) => {
    let preloadingImages: string[] = [];
    if (abPromoInWebviewPublic && abPromoInWebviewPublic.type === 'a') {
        preloadingImages = [animatedTrendVariantA];
    }

    return new PopupModel(
        PROMO_ID,
        models.base,
        new BaseModelProps(PROMO_ID, {
            store: new LocalStorageStore(PROMO_ID, stores.localStorage),
            renderer: new ReactRenderer(PROMO_ID, SuspendedComponent, render.react),
            closable: true,
            showDelay: 3000,
            showLimit: Infinity,
            closeLimit: Infinity,
            showInterval: 24 * 60 * 60 * 1000, // 1 сутки
            templateData: { video: preloadingImages[0] },
            ignoreTestOnRedraw: true,
            ignoreTimeWhenShowed: false,
            ignorePromoShowInterval: true,
            isModelEnabledCheck: () => true,
            test: (resolve, reject) => {
                if (!IS_MOBILE_BROWSER) {
                    reject();
                    return;
                }

                if (!IS_WEBVIEW) {
                    reject();
                    return;
                }

                const state = reduxStore.getState();
                const storage = getCurrentStorage(state);

                if (!abPromoInWebviewPublic || abPromoInWebviewPublic.type === 'c' || abPromoInWebviewPublic.type === 'b') {
                    reject();
                    return;
                }

                // Показываем только в public
                if (storage !== EStorageType.public) {
                    reject();
                    return;
                }

                resolve();
            },
        })
    );
};
